export default __webpack_public_path__ + "static/media/pkg1.4c5f36e6.png";